// extracted by mini-css-extract-plugin
export default {"separator":"divkit-a30bb","separator_orientation_horizontal":"divkit-f529e","separator_orientation_vertical":"divkit-e9e27","separator__inner":"divkit-db7d8"};